var _style, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgOthlLogoWhite = function SvgOthlLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 197 48.7",
    style: {
      enableBackground: "new 0 0 197 48.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.6,11.3 29.3,16.3 45.8,41.2 45.8,48.7 54.8,44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "56.4,43.1 32.9,6.7 5.4,38.8 0,16.2 33.5,3.9 57.6,42.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 28.4,
    className: "st0",
    width: 5.7,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 28.4,
    className: "st0",
    width: 5.7,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4,
    y: 36.4,
    className: "st0",
    width: 5.7,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 36.4,
    className: "st0",
    width: 5.7,
    height: 6.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.7,13.1c0,8.5-5.1,13.6-12.7,13.6c-7.7,0-12.2-5.8-12.2-13.2C50.8,5.8,55.7,0,63.4,0 C71.4,0.1,75.7,6,75.7,13.1z M57,13.5c0,5.1,2.4,8.6,6.3,8.6c4,0,6.2-3.8,6.2-8.8c0-4.6-2.2-8.6-6.3-8.6C59.3,4.7,57,8.5,57,13.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.7,13.6c0-2.3-0.1-4.3-0.2-6h5.1l0.3,2.6H84c0.8-1.2,2.7-3,5.8-3c3.8,0,6.7,2.5,6.7,8.1v11.1h-5.8V15.9 c0-2.4-0.8-4.1-3-4.1c-1.6,0-2.6,1.1-3,2.2c-0.1,0.4-0.2,1-0.2,1.5v10.8h-5.8V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.9,18.8c0.2,2.4,2.6,3.6,5.3,3.6c2,0,3.6-0.3,5.2-0.8l0.8,4c-1.9,0.8-4.3,1.2-6.8,1.2 c-6.4,0-10-3.7-10-9.5c0-4.8,3-10,9.5-10c6.1,0,8.4,4.7,8.4,9.4c0,1-0.1,1.9-0.2,2.3h-12.2V18.8z M111.8,14.8 c0-1.4-0.6-3.8-3.3-3.8c-2.5,0-3.5,2.2-3.6,3.8H111.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.9,5.4H116V0.5h19.9v4.9h-7.1v20.9h-5.9V5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.9,13.7c0-2.8-0.1-4.6-0.2-6.2h5l0.2,3.5h0.2c1-2.7,3.3-3.9,5.1-3.9c0.5,0,0.8,0,1.2,0.1v5.5 c-0.4-0.1-0.9-0.2-1.6-0.2c-2.1,0-3.6,1.2-4,3c-0.1,0.4-0.1,0.8-0.1,1.3v9.5h-5.8L135.9,13.7L135.9,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.3,20.3c0,2.5,0.1,4.4,0.2,6h-5.1l-0.3-2.6H162c-0.7,1.2-2.5,3.1-5.9,3.1c-3.8,0-6.6-2.4-6.6-8.2v-11 h5.9v10.1c0,2.7,0.9,4.4,2.9,4.4c1.6,0,2.5-1.1,2.9-2c0.2-0.3,0.2-0.8,0.2-1.3V7.6h5.9L167.3,20.3L167.3,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.4,21.2c1.1,0.7,3.3,1.4,5,1.4c1.8,0,2.5-0.6,2.5-1.6s-0.6-1.4-2.8-2.1c-3.9-1.3-5.4-3.4-5.3-5.6 c0-3.5,3-6.1,7.6-6.1c2.2,0,4.1,0.5,5.3,1.1l-1,4c-0.8-0.5-2.5-1.1-4.1-1.1c-1.4,0-2.2,0.6-2.2,1.5s0.7,1.3,3,2.1 c3.6,1.2,5.1,3,5.1,5.8c0,3.5-2.8,6.1-8.1,6.1c-2.5,0-4.6-0.5-6.1-1.3L170.4,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.8,2.2v5.4h4.2v4.3h-4.2v6.8c0,2.3,0.5,3.3,2.3,3.3c0.7,0,1.3-0.1,1.7-0.2v4.4c-0.8,0.3-2.1,0.5-3.8,0.5 c-1.9,0-3.5-0.7-4.4-1.6c-1.1-1.1-1.6-2.9-1.6-5.6v-7.7h-2.5V7.5h2.5V3.4L192.8,2.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.8,32.9v4.3h5v-4.3h1.4v10.3h-1.4v-4.8h-5v4.8h-1.3V32.9H83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.9,37.9c0,3.6-2.2,5.4-4.8,5.4c-2.7,0-4.6-2.1-4.6-5.2c0-3.3,2-5.4,4.8-5.4 C99.1,32.7,100.9,34.9,100.9,37.9z M92.9,38.1c0,2.2,1.2,4.2,3.3,4.2c2.1,0,3.3-1.9,3.3-4.3c0-2.1-1.1-4.2-3.3-4.2 C94,33.8,92.9,35.8,92.9,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.9,38.7c-0.1-1.4-0.2-3.2-0.2-4.5l0,0c-0.4,1.2-0.8,2.5-1.3,3.9l-1.8,5h-1l-1.7-4.9 c-0.5-1.5-0.9-2.8-1.2-4l0,0c0,1.3-0.1,3-0.2,4.6l-0.3,4.4h-1.3l0.7-10.3h1.7l1.8,5c0.4,1.3,0.8,2.4,1,3.5l0,0 c0.3-1,0.6-2.2,1.1-3.5l1.8-5h1.7l0.6,10.3H111L110.9,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.5,38.4h-4v3.7h4.5v1.1h-5.8V32.9h5.6V34h-4.3v3.3h4V38.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.1,32.9h1.3v9.2h4.4v1.1H124V32.9H124.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,37.9c0,3.6-2.2,5.4-4.8,5.4c-2.7,0-4.6-2.1-4.6-5.2c0-3.3,2-5.4,4.8-5.4S139.2,34.9,139.2,37.9z  M131.2,38.1c0,2.2,1.2,4.2,3.3,4.2s3.3-1.9,3.3-4.3c0-2.1-1.1-4.2-3.3-4.2C132.3,33.8,131.2,35.8,131.2,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142,39.9l-1.1,3.3h-1.4l3.5-10.3h1.6l3.5,10.3h-1.4l-1.1-3.3H142z M145.4,38.9l-1-3 c-0.2-0.7-0.4-1.3-0.5-1.9l0,0c-0.2,0.6-0.3,1.2-0.5,1.9l-1,3H145.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.3,43.2V32.9h1.5l3.3,5.2c0.8,1.2,1.4,2.3,1.9,3.4l0,0c-0.1-1.4-0.2-2.6-0.2-4.2V33h1.3v10.3h-1.4 l-3.3-5.2c-0.7-1.2-1.4-2.3-1.9-3.5l0,0c0.1,1.3,0.1,2.5,0.1,4.3v4.4h-1.3V43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.8,41.6c0.6,0.4,1.5,0.7,2.4,0.7c1.4,0,2.2-0.7,2.2-1.8c0-1-0.6-1.5-1.9-2.1c-1.7-0.6-2.7-1.5-2.7-2.9 c0-1.6,1.3-2.8,3.3-2.8c1.1,0,1.8,0.2,2.3,0.5l-0.4,1.1c-0.3-0.2-1-0.5-2-0.5c-1.4,0-1.9,0.8-1.9,1.5c0,1,0.6,1.4,2.1,2 c1.7,0.7,2.6,1.5,2.6,3c0,1.6-1.2,3-3.6,3c-1,0-2.1-0.3-2.6-0.7L158.8,41.6z"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOthlLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/othl-logo-white.826214eb.svg";
export { ForwardRef as ReactComponent };